export default {
    baseUrl: 'https://app-dev.helm.orisma.com/',
    apiUrl: "https://api-dev.helm.orisma.com/internal/v1/",
    websocketUrl: "https://wss-dev.tiller.orisma.com"
};